import { render, staticRenderFns } from "./OrganizationsList.vue?vue&type=template&id=803f3362&"
import script from "./OrganizationsList.vue?vue&type=script&lang=js&"
export * from "./OrganizationsList.vue?vue&type=script&lang=js&"
import style0 from "./OrganizationsList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSimpleCheckbox } from 'vuetify/lib/components/VCheckbox';
installComponents(component, {VContainer,VRow,VSimpleCheckbox})
